class StorageHelper {
  constructor(protected readonly store: Storage) {}

  public setItem<T>(key: string, value: T, expiresIn = 21600000): boolean {
    if (!this.store) {
      return false;
    }
    try {
      if (expiresIn > 0) {
        const valueObj = JSON.stringify({
          expiresInTimestamp: new Date().getTime() + expiresIn,
          value: value
        });

        this.store.setItem(key, valueObj);
        return true;
      }

      const serializedState = JSON.stringify(value);
      this.store.setItem(key, serializedState);
      return true;
    } catch (error) {
      return false;
    }
  }

  public getItem<T>(key: string): T | undefined {
    if (!this.store) {
      return;
    }

    try {
      const localStorageItem = this.store.getItem(key);

      if (!localStorageItem) {
        return;
      }

      const item = JSON.parse(localStorageItem);
      if (item && typeof item === "object") {
        if (Object.prototype.hasOwnProperty.call(item, "expiresInTimestamp")) {
          if (item.expiresInTimestamp > Date.now()) {
            return item.value;
          }
          this.removeItem(key);
          return;
        }
        return item;
      }
      return item;
    } catch (error) {
      throw new Error("Store deserialization failed");
    }
  }

  public hasItem(key: string): boolean {
    return (
      Object.prototype.hasOwnProperty.call(this.store, key) &&
      typeof this.store[key] !== undefined
    );
  }

  public removeItem(key: string): boolean {
    try {
      this.store.removeItem(key);
      return true;
    } catch (err) {
      return false;
    }
  }

  public clear(): void {
    this.store.clear();
  }
}

const storageService = new StorageHelper(localStorage);
export default storageService;
